import LinkHvacToThermostat from './LinkHvacToThermostat';

export default LinkHvacToThermostat;
